import(/* webpackMode: "eager" */ "/app/frontend/src/app/(auth)/register/customer/page.tsx");
